import { AiAnalyticsSummaryPageType } from "@redotech/redo-model/conversion/ai-analytics-summary";
import * as z from "zod/v4";

export const getAiAnalyticsSummary = {
  name: "getAiAnalyticsSummary" as const,
  input: z.object({
    pageType: AiAnalyticsSummaryPageType,
    /**
     * PlainDate YYYY-MM-DD window; absent = look up the all-time summary.
     * Both bounds required when present.
     */
    dateRange: z.object({ start: z.string(), end: z.string() }).optional(),
  }),
  output: z.object({
    summary: z.string().nullable(),
    createdAt: z.date().nullable(),
  }),
};
